/** @format */

import * as React from 'react';

export const IconParking = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.54234 1.00008L19.4575 1C21.4139 0.99999 22.9999 2.58596 22.9999 4.54236V19.4576C22.9999 21.4139 21.414 22.9999 19.4576 22.9999L4.54238 23C2.58598 23 1 21.414 1 19.4576V4.54244C1 2.58606 2.58596 1.00009 4.54234 1.00008ZM19.4575 3.11299L4.54235 3.11307C3.75293 3.11307 3.11299 3.75302 3.11299 4.54244V19.4576C3.11299 20.2471 3.75294 20.887 4.54237 20.887L19.4576 20.8869C20.247 20.8869 20.8869 20.247 20.8869 19.4576V4.54236C20.8869 3.75293 20.247 3.11298 19.4575 3.11299ZM8.60351 7.64978C8.60351 7.0663 9.07652 6.59329 9.66 6.59329H13.3888C15.3452 6.59329 16.9312 8.17926 16.9312 10.1356C16.9312 12.092 15.3452 13.678 13.3888 13.678H10.7165V16.3503C10.7165 16.9338 10.2435 17.4068 9.66 17.4068C9.07652 17.4068 8.60351 16.9338 8.60351 16.3503V7.64978ZM10.7165 11.565H13.3888C14.1782 11.565 14.8182 10.9251 14.8182 10.1356C14.8182 9.34623 14.1782 8.70628 13.3888 8.70628H10.7165V11.565Z"
        fill="#313140"
      />
    </svg>
  );
};
